import { WordBankCategory, IWordBank } from 'types'
import { SET_WORD_BANKS } from 'smart-components/top5/store/Actions'
import { IInitiative } from '../Interfaces'

export const GET_USER_PROFILE = 'publicProfileComponent.getUserProfile'

export function getUserProfile(data: any) {
  return {
    type: GET_USER_PROFILE,
    payload: { ...data }
  } as const
}

export function setWordBanks(resource: WordBankCategory, wordBanks: IWordBank[]) {
  return {
    type: SET_WORD_BANKS,
    payload: { [resource]: wordBanks }
  } as const
}

export function setInitiatives(initiatives: IInitiative) {
  return {
    type: SET_WORD_BANKS,
    payload: { initiatives }
  } as const
}

export type PublicProfileAction = ReturnType<typeof getUserProfile | typeof setWordBanks | typeof setInitiatives>
